var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"dots"},[_c('div',{staticClass:"dot"},[_vm._v(_vm._s(_vm.hours))]),_vm._v("H\n    "),_c('div',{staticClass:"dot"},[_vm._v(_vm._s(_vm.minutes))]),_vm._v("M\n    "),_c('div',{staticClass:"dot"},[_vm._v(_vm._s(_vm.seconds))]),_vm._v("S\n")])
}
var staticRenderFns = []

export { render, staticRenderFns }